<template lang="pug">
	.app-core--notifier
		.messages.flex-col.space
			.flex-row.center(v-for="toast in toasts")
				.notify-message.swing-in-top-fwd(:class="[toast.type]", :style="{ '--timeleft': 1 - toast.timeGone / toast.displayTime }")
					.flex-row.space.align-center.justify(@click="() => onToastClick(toast)")
						.flex-col.flex-1
							.text(v-html="toast.formattedMessage")
							.flex-row.justify(v-if="toast.hasHiddenText")
								.left
								.click-more.upper {{$tCaption('Click to see more')}}
						.message-button
							DxButton(icon="close", stylingMode="text", @click="e => { e.event.stopPropagation(); toast.close(); }")
		Popup(v-if="viewingToast", :popupVisible="!!viewingToast" :width="640", :height="480", :title="viewingToast.title || $tCaption('Message')", :closeOnOutsideClick="true" @hiding="viewingToast = null", :showMaximize="true")
			.app-core--notifier
				pre.pre-wrap(v-if="viewingToast.formattedFullMessage")
					.message(v-html="viewingToast.formattedFullMessage")
				JsonViewer(v-if="viewingToast.JSON", :value="viewingToast.JSON", :expanded="true", :expandDepth="jsonViewerExpandLevel")
			template(slot="actions-left")
				DxButton(:text="$tCaption('Copy to clipboard')", icon="fas fa-copy", @click="copyMessage(viewingToast)")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", icon="fas fa-times", @click="viewingToast = false")
</template>

<script>
	import { DxToast } from 'devextreme-vue/toast';
	import { DxButton } from 'devextreme-vue/button';
	import config from 'app-core/config';
	import Popup from 'app-core/Popup.vue';
	import JsonViewer from 'vue-json-viewer';

	export default {
		components: {
			DxToast, DxButton, Popup, JsonViewer
		},
		data() {
			return {
				toasts: [],
				visible: false,
				maxCount: 3,
				maxLength: 120,
				viewingToast: null,
				jsonViewerExpandLevel: 0
			};
		},
		mounted() {
			config.setNotifier(this);
			if (__DEBUG__)
				window.notifier = this;
		},
		computed: {
		},
		methods: {
			onToastClick(toast) {
				if (toast.hasHiddenText) {
					this.viewingToast = toast;
				}
			},
			notify(opts) {
				const message = `${opts.message || opts.htmlMessage}`;

				if (this.toasts[this.toasts.length - 1]?.message === message) {
					this.toasts[this.toasts.length - 1].close();
					setTimeout(() => this.notify(opts), 50);
					return;
				}

				this.jsonViewerExpandLevel = opts?.jsonExpandLevel || 1;

				const toast = {
					id: this.$Data.uuid(),
					type: 'success',
					displayTime: 7000,
					...opts,
					message,
					formattedMessage: this.formatMessage(opts.message || opts.htmlMessage),
					formattedFullMessage: opts?.JSON ? null : message.replace(/\n/g, '<br>'),
					JSON: opts?.JSON,
					hasHiddenText: (message.length > this.maxLength) || opts?.JSON,
					timeGone: 0
				};
				
				var closeTimeout = setTimeout(() => toast.close(), toast.displayTime);
				var timerInterval = setInterval(() => toast.timeGone += 50, 50);
				toast.close = () => {
					var idx = this.toasts.findIndex(f => f.id === toast.id);
					if (idx > -1)
						this.toasts.splice(idx, 1);
					clearTimeout(closeTimeout);
					clearInterval(timerInterval);
				};

				if (!opts?.fullScreen) {
					this.toasts.push(toast);
				}
				this.visible = false;

				if (opts?.fullScreen) {
					this.viewingToast = toast;
				}
				
				if (this.toasts.length > this.maxCount) {
					this.toasts.slice(0, this.toasts.length - this.maxCount).map(f => f.close());
				}
			},
			formatMessage(msg) {
				var message = `${msg}`;
				return `${message.slice(0, this.maxLength)}${message.length > this.maxLength ? '...' : ''}`.replace(/\n/g, '<br>');
			},
			copyMessage(message) {
				let msg = message.JSON ? JSON.stringify(message.JSON, void 0, '    ') : message.message;
				if (navigator?.clipboard?.writeText) {
					navigator.clipboard.writeText(msg);
				}
			}
		}
	};
</script>
<style lang='scss'>
	.app-core--notifier {
		> pre {
			margin: 0px !important;
			font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
		}
		.messages {
			position: fixed;
			bottom: 20px;
			left: 50%;
			transform: translateX(-50%);
			z-index: 10000;

			.notify-message {
				min-height: 30px;
				min-width: 80px;
				background: #6eb56e;
				border-radius: 4px;
				border: 1px solid rgba(255, 255, 255, 0.2);
				box-shadow: 0 2px 3px rgb(0 0 0 / 25%);
				padding: 4px 4px 4px 15px;
				color: #fff;
				font-size: 14px;
				min-width: 300px;

				.click-more {
					font-size: 9px;
					color: #ffffffad;
				}

				.text {
					padding: 6px;
				}

				.message-button {
					position: relative;

					> .dx-button-mode-text .dx-icon {
						color: rgb(255, 255, 255, .7) !important;
					}

					&:after {
						position: absolute;
						content: '';
						padding: 2px;
						width: 100%;
						height: 100%;
						box-sizing: border-box;
						-webkit-mask: conic-gradient(#000 calc(var(--timeleft) * 360deg), transparent calc(var(--timeleft) * 360deg)), linear-gradient(#000, #000) content-box;
						-webkit-mask-composite: source-out;
						mask-composite: subtract;
						background: rgba(255,255,255,0.4);
						border-radius: 50%;
						pointer-events: none;
						left: 0px;
					}
				}

				&.success {
					background: #6eb56e;
				}

				&.error {
					background: #ff5c5c;
				}

				&.warning {
					background: #ff9771;
				}

				&.info {
					background: #4c79b0;
				}

				&:hover {
					cursor: pointer;
					opacity: 0.9;
				}
			}

			.swing-in-top-fwd {
				animation: swing-in-top-fwd 0.5s cubic-bezier(0.175, 0.885, 0.320, 1.275) both;
			}

			@keyframes swing-in-top-fwd {
				0% {
					transform: rotateX(-100deg);
					transform-origin: top;
					opacity: 0;
				}
				100% {
					transform: rotateX(0deg);
					transform-origin: top;
					opacity: 1;
				}
			}
		}
	}
</style>
